import i18next from 'i18next'
import * as React from 'react'
import { AsyncState, IOWidget, Updater, any, fromJSX } from 'widgets-for-react'
import { UserSubscriptions } from '../../../../subscription/subscriptionState'
import { TextPageHeader } from '../../pageHeader/pageHeaderLayout'
import { paywallWidget } from '../../paywall/paywallWidget'
import { KnowledgeTypeTeasersState } from '../knowledgeTypeTeasers/knowledgeTypeTeasersState'
import { knowledgeTypeTeasersWidget } from '../knowledgeTypeTeasers/knowledgeTypeTeasersWidget'

export const knowledgeOverviewWidget =
  (
    isLoggedIn: boolean,
    userSubscriptionsState: AsyncState<UserSubscriptions>
  ): IOWidget<KnowledgeTypeTeasersState, Updater<KnowledgeTypeTeasersState>> =>
  (knowledgeTypeTeasersState) =>
    any([
      fromJSX(() => (
        <TextPageHeader
          title={i18next.t('knowledge:knowledgeTitle')}
          intro={i18next.t('knowledge:knowledgeIntro')}
        />
      )),
      paywallWidget(isLoggedIn, userSubscriptionsState)(
        knowledgeTypeTeasersWidget(knowledgeTypeTeasersState),
        knowledgeTypeTeasersWidget(knowledgeTypeTeasersState)
      ),
    ])
